export enum MerchantTabs {
  general = "general",
  managers = "managers",
  invitations = "invitations",
  settings = "settings",
}

export interface ITabPanelProps {
  open: boolean;
}
